import { useEffect, useState } from 'react';
import './Case.css';
import Banner from '../../Components/Layout/Banner/Banner.js';

function Case() {
    const [caseList, setCaseList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState('전체'); // 카테고리 상태
    const itemsPerPage = 6;

    // 카테고리 목록 정의
    const categories = ['전체', '형사', '민사', '가사', '상속', '성범죄', '기타'];

    const JSON_URL = "https://raw.githubusercontent.com/ChordCon/onpyeong/refs/heads/main/case.json";

    useEffect(() => {
        fetch(JSON_URL)
            .then(response => response.json())
            .then(data => {
                const sortedData = [...data].reverse();
                setCaseList(sortedData);
                setLoading(false);
            })
            .catch(error => {
                console.error("데이터 로딩 실패:", error);
                setLoading(false);
            });
    }, []);

    if (loading) return (
        <>
            <Banner />
            <div className="text-center py-5">사례를 불러오는 중입니다...</div>
        </>
    );

    // [핵심] 선택된 카테고리에 따라 리스트 필터링
    const filteredItems = selectedCategory === '전체'
        ? caseList
        : caseList.filter(item => item.category === selectedCategory);

    // 페이지네이션 로직 (filteredItems 기준)
    const lastItemIndex = currentPage * itemsPerPage;
    const firstItemIndex = lastItemIndex - itemsPerPage;
    const currentItems = filteredItems.slice(firstItemIndex, lastItemIndex);
    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    // 카테고리 변경 함수
    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        setCurrentPage(1); // 카테고리 변경 시 첫 페이지로 이동
    };

    return (
        <>
            <Banner />
            <div className="py-5 container">

                {/* 카테고리 필터 버튼 영역 */}
                <div className="category-filter-wrapper mb-5 text-center">
                    {categories.map((cat) => (
                        <button
                            key={cat}
                            className={`btn filter-btn ${selectedCategory === cat ? 'active' : ''}`}
                            onClick={() => handleCategoryChange(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>

                <div className="row g-4">
                    {currentItems.length > 0 ? (
                        currentItems.map((item) => (
                            <div className="col-md-4" key={item.id}>
                                <div
                                    className="case-card h-100 p-4 border shadow-sm d-flex flex-column" // d-flex flex-column 추가
                                    onClick={() => window.open(item.link, '_blank')}
                                >
                                    {/* 상단 내용 영역 */}
                                    <div className="case-content-top flex-grow-1">
                                        <span className="badge bg-gold mb-3">{item.category}</span>
                                        <h4 className="fw-bold mb-3">{item.title}</h4>
                                        <p className="text-secondary case-desc">{item.desc}</p>
                                    </div>

                                    {/* 하단 버튼 영역 - 항상 아래에 고정 */}
                                    <div className="case-content-bottom mt-auto pt-3">
                                        <div className="text-primary text-decoration-none fw-bold">
                                            자세히 보기 →
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-5 text-muted">해당 카테고리의 사례가 아직 없습니다.</div>
                    )}
                </div>

                {/* 페이지네이션 UI */}
                {totalPages > 1 && (
                    <nav className="mt-5">
                        <ul className="pagination justify-content-center">
                            {Array.from({ length: totalPages }, (_, i) => (
                                <li key={i + 1} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                    <button
                                        onClick={() => paginate(i + 1)}
                                        className="page-link custom-page-link"
                                    >
                                        {i + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                )}
            </div>
        </>
    );
}

export default Case;